export class MeetingRoomSelectors {
  static meetingRooms = 'meetingRooms';
  static meetingRoomRequirements = 'meetingRoomRequirements';
  static attendance = 'attendance';
}
